import React, { useMemo } from 'react';
import { getSalesGoalsConditions, getSalesGoalsData } from '../../helpers/boh_spotlights';
import { getCurrentDateInMillis, getSpecificDateInMillis } from '../../../helpers/utils';
import BottomBar from '../../../components/BottomBar';
import Goal from './Goal';
import { CongratulationsRunner } from '../CongratulationsRunner';
import GoalUnreachedMessage from '../GoalUnreachedMessage';
import SpotlightHeader from '../../Common/Header';
import './PercentageToGoal.scss';
const PercentageToGoal = props => {
  const {
    metadata,
    text,
    data,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    group_name,
    timezone
  } = data;
  const {
    boh_goals,
    boh_date_range,
    boh_event_type
  } = metadata;
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const {
    accent_color,
    title_color,
    body_color,
    text_accent_color,
    body_font_family,
    containerStyle
  } = bohStyle;

  // TODO: Remove this useMemo. Currently needed to prevent GSAP breaking
  const salesData = useMemo(() => getSalesGoalsData(boh_goals, data), [boh_goals, data]);
  const {
    goal,
    stretch_goal,
    sales
  } = salesData;
  const {
    endDate,
    endTime
  } = boh_date_range !== null && boh_date_range !== void 0 ? boh_date_range : {};
  const isDateRangeFinished = boh_event_type === 'custom' && getCurrentDateInMillis(timezone) > getSpecificDateInMillis(endDate, endTime, timezone);

  // TODO: Remove this useMemo. Currently needed to prevent GSAP breaking
  const salesGoalsConditions = useMemo(() => getSalesGoalsConditions(salesData, isDateRangeFinished), [salesData, isDateRangeFinished]);
  const {
    showStretchGoal,
    showCongratulations,
    showGoalUnreached
  } = salesGoalsConditions;
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    group_name: group_name,
    showUpdatedTime: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "percentage-sales-goal",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(CongratulationsRunner, {
    color: accent_color,
    textColor: title_color,
    firstText: "GOAL REACHED",
    secondText: "CONGRATULATIONS!",
    header: Header,
    timeout: (duration - 5) * 1000,
    showCongratulations: playing && showCongratulations
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: `percentages-to-goal ${showStretchGoal ? 'stretch' : ''}`
  }, /*#__PURE__*/React.createElement(Goal, {
    goal: goal,
    sales: playing ? sales : 0,
    goal_description: "GOAL",
    body_font_family: body_font_family,
    body_color: body_color,
    playing: playing
  }), showStretchGoal && /*#__PURE__*/React.createElement(Goal, {
    goal: stretch_goal,
    sales: playing ? sales : 0,
    goal_description: "STRETCH GOAL",
    body_font_family: body_font_family,
    body_color: body_color,
    playing: playing
  }), showGoalUnreached && /*#__PURE__*/React.createElement(GoalUnreachedMessage, null)), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  })));
};
export default PercentageToGoal;